import React from 'react';

import FooterComponent from '../footer/FooterComponent';
import HeaderNavComponent from '../header/HeaderNavComponent';

export const CategoryDirectoryTemplate = props => {
    return (
        <div className="template template-category-directory flex-container-v">
            <HeaderNavComponent />
            {React.cloneElement(props.children)}
            <FooterComponent />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/template/CategoryDirectoryTemplate.js